import { styled } from '@zoopla-eng/zds-components/themes';

export const BannerTitle = styled('h2', {
    color: '$textTitle',
    fontGroup: 'plate',
    fontWeight: '$400',
    fontSize: '$plateSmall',

    '@M100': {
        fontSize: '$plateMedium'
    },

    '@L100': {
        fontSize: '$plateLarge'
    }
});

export const BannerContainer = styled('div', {
    background: '$brandPrimaryT4',
    borderRadius: '$radii$400',
    overflow: 'hidden',

    color: '$textBody',
    display: 'flex',

    variants: {
        imagePosition: {
            top: {
                flexDirection: 'column-reverse',
                '@M100': {
                    flexDirection: 'row'
                }
            },
            bottom: {
                flexDirection: 'column',
                '@M100': {
                    flexDirection: 'row'
                }
            }
        },
        bgColor: {
            purple: {
                background: '$purpleT4'
            },
            white: {
                background: '$whiteT4'
            },
            green: {
                background: '$greenT4'
            },
            blue: {
                background: '$blueT4'
            },
            maroon: {
                background: '$maroonT4'
            },
            orange: {
                background: '$orangeT4'
            }
        }
    }
});
